module.exports = __webpack_public_path__ + "static/media/frameExplore.b5ec2c30.png";